/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect, useRef } from 'react';
import {
  DIALOG_RESULT_OK,
  DIALOG_RESULT_CANCEL,
} from '@src/constants';

const withGlobalPromptDialog = (WrapComponent, setDialog) => (props) => {
  const promiseRef = useRef({});
  const [open, setOpen] = useState(false);
  const [confirmDialogProps, setConfirmDialogProps] = useState({});

  function confirmHandle(inputValue) {
    if (promiseRef.current.promise) {
      promiseRef.current.resolve({
        result: DIALOG_RESULT_OK,
        value: inputValue,
      });
    }

    setOpen(false);
  }

  function closeHandle() {
    if (promiseRef.current.promise) {
      promiseRef.current.resolve({
        result: DIALOG_RESULT_CANCEL,
        value: '',
      });
    }

    setOpen(false);
  }

  function handleChange(newValue) {
    setConfirmDialogProps((oldState) => ({
      ...oldState,
      value: newValue,
    }));
  }

  useEffect(() => {
    setDialog({
      show: (dialogProps) => {
        setOpen(true);
        const {
          onConfirm, onClose, onChange,
        } = dialogProps;
        const newOnClose = () => onClose && closeHandle(onClose);
        const newOnConfirm = () => onConfirm && confirmHandle(onConfirm);

        const newOnChange = (newValue) => {
          onChange && onChange(newValue);
          handleChange(newValue);
        };

        setConfirmDialogProps({
          ...dialogProps,
          onConfirm: newOnConfirm,
          onClose: newOnClose,
          onChange: newOnChange,
        });

        promiseRef.current.promise = new Promise((resolveX, rejectX) => {
          promiseRef.current.resolve = resolveX;
          promiseRef.current.reject = rejectX;
        });

        return promiseRef.current.promise;
      },
    });
  }, [confirmDialogProps]);

  return (
    <WrapComponent
      {...confirmDialogProps}
      open={open}
      onConfirm={confirmHandle}
      onClose={closeHandle}
    />
  );
};

export default withGlobalPromptDialog;
